import { useOutletContext } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { useMiningData } from "api/mining";
import { useElectricityData } from "api/electricity";
import { useHeatData } from "api/heat";
import { useGasData } from "api/gas";

import ThermalEfficiency from "components/ThermalEfficiency";
import ThermalCost from "components/ThermalCost";
import EarningsVsCost from "components/EarningsVsCost";
import ElectricityConsumption from "components/ElectricityConsumption";
import ElectricityEarnings from "components/ElectricityEarnings";

export default function Dashboard() {
  const { user } = useAuth0();

  const [farmName, dayRange] = useOutletContext<any>();

  const { data: miningData } = useMiningData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: electricityData } = useElectricityData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: heatData } = useHeatData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: gasData } = useGasData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);

  const { eurosImportedFromGrid = 0, eurosSoldToGrid = 0 } = electricityData?.total ?? {};
  const { eurosMined = 0 } = miningData?.total ?? {};
  const { eurosGasConsumed = 0 } = gasData?.total ?? {};

  return (
    <>

      <div className="mt-5 px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto grid gap-5 md:grid-cols-2 lg:grid-cols-3 items-start">
        <div className="space-y-5">
          <ThermalEfficiency data={heatData ? heatData.total : null} showBars />
          <ThermalCost gasData={gasData ? gasData.total : null} heatData={heatData ? heatData.total : null} showBars />
        </div>
        <div className="space-y-5">
          <EarningsVsCost miningData={miningData} electricityData={electricityData} gasData={gasData} showBars />
        </div>
        <div className="space-y-10">
          <ElectricityConsumption electricityData={electricityData?.total} showBars />
          <ElectricityEarnings electricityData={electricityData?.total} showBars />
        </div>
      </div>

      <div className="mt-5 px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto ">
        <div className="grid xl:grid-cols-3 items-center overflow-hidden font-['Avenir'] bg-white rounded border border-gray-200">
          <div className="text-gray-600 text-2xl 2xl:text-3xl font-bold p-7">Total Project Earnings</div>
          <div className="py-6 px-8">
            <div className="flex justify-between items-center">
              <div className="text-xs text-slate-400">Gross Project Earnings:</div>
              <div className="text-2xl text-blue-600 font-bold">
                {(eurosSoldToGrid + eurosMined).toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
              </div>
            </div>
            <div className="flex justify-between items-center border-t my-1 py-1">
              <div className="text-xs text-slate-400">Project Costs:</div>
              <div className="text-2xl text-cyan-600 font-bold">
                {(eurosImportedFromGrid + eurosGasConsumed).toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
              </div>
            </div>
          </div>
          <div className="py-7 px-8 bg-slate-100 border-l border-t border-gray-100 text-right xl:text-left">
            <div className="text-gray-400 text-sm">Project Revenue (Net):</div>
            <div className="my-3 text-blue-600 text-5xl font-[Avenir-Bold]">
              {(eurosSoldToGrid + eurosMined - eurosImportedFromGrid - eurosGasConsumed).toLocaleString("en-GB", {
                style: "currency",
                currency: "EUR",
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
